import { render, staticRenderFns } from "./chooseLink.vue?vue&type=template&id=11c8c804&scoped=true"
import script from "./chooseLink.vue?vue&type=script&lang=ts"
export * from "./chooseLink.vue?vue&type=script&lang=ts"
import style1 from "./chooseLink.vue?vue&type=style&index=1&id=11c8c804&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c8c804",
  null
  
)

export default component.exports